// lego Gifting available only for these events
// In cstools, the feature switch is called 'lego|'
// Added | to distinguish FE features and also for 'evite.feature' to work properly.
export const LEGO_FEATURE_NAME = 'lego';

const LEGO_ENABLE_EVENT_TYPES = ['birthday_forkids', 'holidayforkids'];
// TODO: this data should be obtained from cms
export const LEGO_DATA = {
  feature_name: LEGO_FEATURE_NAME,
  sponsor_name: 'lego',
  supported_event_types: LEGO_ENABLE_EVENT_TYPES,
  enable_message: 'Allow guests to send Lego gifts for this event',
  logo_image: 'logo.jpg',
  banner_image: 'banner.jpg',
  banner_mobile_image: 'banner_mobile.jpg',
  seeMoreLink: `https://ad.doubleclick.net/ddm/trackclk/N789069.3135113EVITE/B21632402.228530068;dc_trk_aid=429885086;dc_trk_cid=107694123;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`,
  gifting_link_compact: `https://ad.doubleclick.net/ddm/trackclk/N789069.3135113EVITE/B21632402.228530068;dc_trk_aid=429885086;dc_trk_cid=107694123;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`,
  gifting_link: `https://ad.doubleclick.net/ddm/trackclk/N789069.3135113EVITE/B21632402.228530068;dc_trk_aid=429885086;dc_trk_cid=107694123;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`,
};
